// import { Moon, Sun } from "lucide-react";

import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useTranslation } from "@/providers/language-provider";

const Languages = {
  en: "English",
  ko: "한국어",
} as const;

export function LanguageToggle() {
  const { t, language, setLanguage } = useTranslation();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline">
          {Languages[language]}
          <span className="sr-only">{t("UserMenu")}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={() => setLanguage("en")}>
          {Languages.en}
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => setLanguage("ko")}>
          {Languages.ko}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
